import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  Table,
} from "react-bootstrap";
import { Download, TimeControlInbound } from "../components";
import { stringDateTimeReceipt, stringYMDHMS3 } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import { goToTop, handleDigit } from "../Utility/function";
import * as XLSX from 'xlsx';
import { normalSort } from "../Utility/sort";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate , Outlet, NavLink } from 'react-router-dom';


function InboundVenderScreen() {
    const navigate = useNavigate();
    const { displayInbounds, startDate, endDate } = useSelector((state)=> state.inbound);

    const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const { display, totalCost, totalQty, averageCost, totalPo } = useMemo(()=>{
        let display = []
        let totalCost = 0;
        let totalQty = 0;
        let totalPo = 0;
        for(const { totalCost:cost, totalQty:qty, supplier: { vender_Name, tel, id } } of displayInbounds ){
            let findVender = display.find(a=>a.id === id)
            if(findVender){
                findVender.cost += cost
                findVender.qty += qty
                findVender.po += 1
            } else {
                display.push({
                    cost,
                    qty,
                    name:vender_Name,
                    tel,
                    id,
                    po:1
                })
            };
            totalCost += cost
            totalQty += qty
            totalPo ++
        }
        if(totalCost>0){
            display = display.map(item=>{
                const { cost, qty, ...rest} = item;
                return {
                    ...rest,
                    cost:handleDigit(cost),
                    qty:handleDigit(qty),
                    rate:handleDigit(cost*100/totalCost),
                    averageCost:qty>0?handleDigit(cost/qty):0
                }
            })
        }
        const averageCost = totalQty>0?handleDigit(totalCost/totalQty):0;
        return {
            display:normalSort('cost',display),
            totalCost:handleDigit(totalCost),
            totalQty:handleDigit(totalQty),
            averageCost,
            totalPo
      }
  },[displayInbounds])
  
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // start form 0
        goToTop()
    };
  
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        goToTop()
    };

    useEffect(()=>{
        let fData = display.map((item,index)=>{return({ ...item, no:index +1 })}).filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
        setCurrentDisplay(fData);

    },[page,rowsPerPage,display]);

    const exportToXlsx = () => {
        const data = display.map((item, index) => {
          const { profileName, timestamp, name, qty, unit } = item;
   
 
          return {
            no: index + 1,
            เวลา: stringDateTimeReceipt(timestamp),
            รายการสินค้า: name,
            จำนวน: qty,
            หน่วย: unit, // Convert to number
            พนักงาน: profileName,
          };
        });
      
        // Create Excel worksheet & workbook
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "รายงานรับเข้าสต๊อก");
      
        // Generate filename dynamically
        const fileName = `รายงานรับเข้าสต๊อก${stringYMDHMS3(startDate)}-${stringYMDHMS3(endDate)}.xlsx`;
        
        // Save the file
        XLSX.writeFile(workbook, fileName);
      };

  return (
    <div style={{minHeight:'100vh'}} >
        <h1>รายงานสินค้า</h1>
        <TimeControlInbound  />
        <div style={styles.container2} >
            <h4>&emsp;ค้นพบ {displayInbounds.length} รายการ</h4> 
            {/* <Download exportToXlsx={exportToXlsx} /> */}
        </div>
        <br/>
        <Table striped bordered hover responsive  variant="light"   >
            <thead  >
                <tr>
                    <th style={{textAlign:'center', width: '10%'}} >No.</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >รายการ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ต้นทุนรวม</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >จำนวน</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ต้นทุนเฉลี่ย</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >สัดส่วน</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ใบรับสินค้า</th>

                </tr>
            </thead>
            <tbody  >
            {currentDisplay.map((item, index) => {
                const { name, cost, qty, rate, averageCost, no, po } = item;
                return <tr   style={{cursor: 'pointer'}} key={index} >
                            <td style={{textAlign:'center'}}>{no}.</td>
                            <td >{name}</td>
                            <td style={{textAlign:'center'}}>{cost}</td>
                            <td style={{textAlign:'center'}}>{qty}</td>
                            <td style={{textAlign:'center'}}>{averageCost}</td>
                            <td style={{textAlign:'center'}}>{rate}</td>
                            <td style={{textAlign:'center'}}>{po}</td>
                        </tr>
            })}
            <tr   >
                <td colSpan={2} style={{textAlign:'center'}}>รวม</td>
                <td style={{textAlign:'center'}}>{totalCost}</td>
                <td style={{textAlign:'center'}}>{totalQty}</td>
                <td style={{textAlign:'center'}}>{averageCost}</td>
                <td style={{textAlign:'center'}}>100.00</td>
                <td style={{textAlign:'center'}}>{totalPo}</td>
            </tr>
            </tbody>
        </Table>
        <TablePagination
            component="div"
            count={displayInbounds.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </div>
  );
};

const styles = {
    container2 : {
      display:'flex',justifyContent:'space-between',marginRight:'1rem'
    },
 
  }

export default InboundVenderScreen;